import React from "react";
import ScrollOrigin from "../components/ScrollOrigin";
import styled from "styled-components";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { pageTransition, transit } from "../animate";
import { titleAnim, fade, photoAnim } from "../Animations";
import cutie1 from "./../icons/cutie1.jpg";
import cutie2 from "./../icons/cutie2.jpg";
import cutie3 from "./../icons/cutie3.jpg";

const Home = () => {
  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={pageTransition}
      transition={transit}
    >
      <Nav />
      <FlexContainer>
        <motion.div variants={titleAnim} initial="hidden" animate="show">
          <Action>
            <motion.h1 variants={titleAnim}>
              Try our pairing questionnaire and find out which dog best fits
              your lifestyle. Our mission is to connect everyone to their
              perfect dog.
            </motion.h1>
            <HomeButton variants={fade}>
              <Link
                to="/start"
                title="start questionnaire"
                alt="start questionnaire"
              >
                Try Now
              </Link>
            </HomeButton>
          </Action>
        </motion.div>
        <HomePhotos>
          <ul>
            <div style={{ width: 256, height: 210 }}>
              <motion.img
                variants={photoAnim}
                initial="hidden"
                animate="show"
                src={cutie1}
                alt="golden"
                style={{
                  height: "100%",
                  width: "100%",
                  display: "block",
                  objectFit: "cover",
                }}
              />
            </div>
            <div style={{ width: 256, height: 210 }}>
              <motion.img
                variants={photoAnim}
                initial="hidden"
                animate="show"
                src={cutie2}
                alt="golden"
                style={{
                  height: "100%",
                  width: "100%",
                  display: "block",
                  objectFit: "cover",
                }}
              />
            </div>
            <div style={{ width: 176, height: 210 }}>
              <motion.img
                variants={photoAnim}
                initial="hidden"
                animate="show"
                src={cutie3}
                alt="golden"
                style={{
                  height: "100%",
                  width: "100%",
                  display: "block",
                  objectFit: "cover",
                  borderRadius:"20px 0 0 20px",
                }}
              />
            </div>
          </ul>
        </HomePhotos>
      </FlexContainer>
      <ScrollOrigin />
      <Footer />
    </motion.div>
  );
};

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 62.5vh;
  scroll-behavior: smooth;
`;

const Action = styled.div`
  display: flex;
  flex-direction: column;
  margin: 4rem 5rem 1rem 13rem ; 
  font-family: 'Cormorant', serif;
`;

const HomeButton = styled(motion.Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  margin: 1rem 0rem 11.9rem 0rem;
  height: 3rem;
  width: 10rem;
  border-radius: 30px;
  text-decoration: none;
  color: white;
  cursor: pointer;
  background-color: #5e9c98;
  font-family: "Open Sans", sans-serif;
  &:hover {
    background-color: #375c5a;
    color: white;
  }
`;

const HomePhotos = styled(motion.div)`
  ul {
    display: flex;
    height: 50%;
    margin-top: 4rem;
    width: 40vw;
    justify-content: space-between;
  }
`;

export default Home;
